import { z } from 'zod';
import { Guest } from './guest';

export enum TableShape {
  ROUND = 'round',
  RECTANGULAR = 'rectangular',
}

export enum TableTab {
  DETAILS = 'details',
  GUESTS = 'guests',
}

export const TablePositionSchema = z.object({
  x: z.number(),
  y: z.number(),
});

export const TableSchema = z.object({
  shape: z.nativeEnum(TableShape),
  position: TablePositionSchema,
  seatCount: z.number(),
  label: z.string().optional(),
  number: z.number(),
  length: z.number().optional(),
  width: z.number().optional(),
});

export type TablePosition = z.infer<typeof TablePositionSchema>;
export type Table = z.infer<typeof TableSchema>;

export interface TableWithGuests extends Table {
  guests: Guest[];
}

export class TableClass implements Table {
  shape: TableShape;
  position: TablePosition;
  seatCount: number;
  label?: string | undefined;
  number: number;
  length?: number | undefined;
  width?: number | undefined;

  constructor(data?: Partial<Table>) {
    const parsedData = TableSchema.partial().parse(data || {});
    this.shape = parsedData.shape ?? TableShape.ROUND;
    this.position = parsedData.position ?? { x: 0, y: 0 };
    this.seatCount = parsedData.seatCount ?? 0;
    this.label = parsedData.label ?? '';
    this.number = parsedData.number ?? 0;
    this.length = parsedData.length ?? 0;
    this.width = parsedData.width ?? 0;
  }
}
